import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function incomeStatementEmbracing(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@incomeStatementEmbracing/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@incomeStatementEmbracing/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@incomeStatementEmbracing/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}